import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

// Define a type for the slice state

// Define the initial state using that type

const initialState = {
  actionRequiredValue: "Leave",
  actionRequiredEventName: "leave",
  actionRequiredFromDate: moment().format("YYYY-MM-DD"),
  actionRequiredToDate: moment().add(1, "d").format("YYYY-MM-DD"),
  actionRequiredData: [],
  actionRequiredDataTemp: [],
  actionRequiredActions: [],
};

const actionRequiredSlice = createSlice({
  name: "actionRequiredValue",

  initialState,
  reducers: {
    setARValue: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.actionRequiredValue = payload;
    },
    setAREventName: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.actionRequiredEventName = payload;
    },
    setARValueFromDate: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.actionRequiredFromDate = payload;
    },
    setARValueToDate: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.actionRequiredToDate = payload;
    },
    setARData: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.actionRequiredData = payload;
    },
    setARDataTemp: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.actionRequiredDataTemp = payload;
    },
    setARActions: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.actionRequiredActions = payload;
    },
    resetARValue: (state: any) => {
      state.actionRequiredValue = "";
      state.actionRequiredEventName = "";
      state.actionRequiredFromDate = "";
      state.actionRequiredToDate = "";
      state.actionRequiredData = [];
      state.actionRequiredActions = [];
      state.actionRequiredDataTemp = [];
    },
  },
});

export const {
  setARValue,
  setAREventName,
  setARValueFromDate,
  setARValueToDate,
  setARActions,
  setARData,
  setARDataTemp,
  resetARValue,
} = actionRequiredSlice.actions;

export default actionRequiredSlice.reducer;
